import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate/sections/sections/Services";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate/sections/sections/ArticleContent";

function CuratenieSuprafeteVitratePage() {
    return (
        <>
            <Helmet>
                <title>Curățare profesională Geamuri & Suprafețe Vitrate | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Curățare profesională geamuri și suprafețe vitrate pentru spații rezidențiale și comerciale. Intervenții eficiente, fără zgârieturi, pentru un rezultat impecabil."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatare-geamuri-suprafete-vitrate/"
                />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Cât de des ar trebui curățate geamurile la o clădire de birouri?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Recomandăm o curățare aprofundată de cel puțin două ori pe an (primăvara și toamna), dar depinde mult de zona în care este amplasată clădirea și de nivelul de poluare."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Se pot curăța geamurile dacă plouă?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nu recomandăm intervenția în condiții de ploaie sau vânt puternic, atât din motive de siguranță a echipei, cât și pentru că rezultatul final nu ar fi la standardele noastre de calitate."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Curățați și jaluzelele sau roletele?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Da, oferim și servicii de curățare pentru jaluzele și rolete, ca serviciu complementar la spălarea geamurilor."
                    }
                    }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CuratenieSuprafeteVitratePage;
